import axios from "axios";
import dayjs from "dayjs";

const _today = dayjs();




const _axios = () =>
  axios.create({
    baseURL: process.env.VUE_APP_API_BASE_PATH,
  });

const GET = {
    INITIATE_TRANSACTION: async ({
      sessionId,
      orderId,
      returnUrl,
      paymentTypeId,
      registerId,
    }) =>
      _axios().get(
        `${process.env.VUE_APP_API_BASE_PATH}/InitiateTransaction?sessionId=${sessionId}&orderId=${orderId}&returnUrl=${returnUrl}&paymentTypeId=${paymentTypeId}${
          registerId ? "&registerId=" + registerId : ""
        }`
      ),
  MENU_ITEMS: async ({ menuHash, sessionId }) =>
     _axios().get(`/GetMenu?MenuHash=${menuHash}&sessionId=${sessionId}`),
    MENU_ITEM: async ({ menuHash, categoryId, menuItemId }) =>
      _axios().get("/GetMenuItemOrdering", {
        params: {
          MenuHash: menuHash,
          CategoryId: categoryId,
          MenuItemId: menuItemId,
        },
      }),
  ORDER_SCREEN: async (token, { showPickedUp, showFailed, data }) =>
    _axios().post("/GetLastPaidOrdersForDay", data, {
      headers: { Authorization: token },
      params: {
        OrderDeliveryDate: _today.format("YYYY-MM-DD"),
        showPickedUp,
        showFailed,
      },
    }),
  }

const PATCH = {
  ORDER: async (payload) => _axios().put("/PatchOrder", payload),
};

export { GET, PATCH };
